var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", {
    ref: "eChatRef",
    class: _vm.eChatClasses,
    attrs: { id: _vm.id, "data-section": _vm.section },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }